import deriveIframeOriginFromRootPageOrigin from '../utils/deriveIframeOriginFromRootPageOrigin.js';
import deriveRootLayoutCssTextFromProps from '../utils/deriveRootLayoutCssTextFromProps.js';
import webZephrIframePropsMergeTopPageMetadata from '../utils/webZephrIframePropsMergeTopPageMetadata.js';
import waitForBouncex from '../utils/waitForBouncex.js';

const RENDER_INLINE_CAMPAIGN_AFTER_PARAGRAPH_NUMBER = 8;

async function onZephrInitializeComponent(e) {
  if (__DEV__) {
    console.log('Web.Zephr:event: onZephrInitializeComponent', e);
  }

  await waitForBouncex();
  const shouldSkipDueToWunderkindCampaignConflict =
    document.querySelector('[id^=bx-campaign]') ||
    (window.bouncex && window.bouncex.campaigns);
  if (shouldSkipDueToWunderkindCampaignConflict) {
    console.info(
      'Web.Zephr:event:onZephrInitializeComponent: exit early due to presence of conflicting wunderkind campaign (e.g., [id^=bx-campaign])',
    );
    return;
  }

  const { detail = {} } = e;

  const {
    urlSearchParams: urlSearchParamsProp,
    componentName,
    // currentScript,
  } = detail;

  if (!componentName) {
    return console.error('Web.Zephr:Error: componentName is required', detail);
  }

  const inlineComponentNamePattern = /^inline/i;
  const isInlineComponent = inlineComponentNamePattern.test(componentName);

  const targetElementSelector = isInlineComponent
    ? '.Article .group p'
    : 'body';
  const targetElement = isInlineComponent
    ? document.querySelectorAll(targetElementSelector)[
        RENDER_INLINE_CAMPAIGN_AFTER_PARAGRAPH_NUMBER
      ]
    : document.querySelector(targetElementSelector);

  if (!targetElement) {
    console.warn(
      `Web.Zephr:Warn: onZephrInitializeComponent event target element document.querySelector('${targetElementSelector}') does not exist.`,
      detail,
    );
    return;
  }

  // todo:future: we should consider validating that the values we are setting (like minHeight, maxHeight, etc.) are of the expected types and formats.
  const {
    minHeight,
    maxHeight,
    minWidth,
    maxWidth,
    position,
    bottom,
    top,
    left,
    right,
    display = 'none',
    trigger: triggerProp = null,
    intent = null,
    showDelayMilliseconds,

    ...webZephrIframeProps
  } = urlSearchParamsProp;

  const iframe = document.createElement('iframe');
  iframe.allowTransparency = true;

  const layoutProps = {
    minHeight,
    maxHeight,
    minWidth,
    maxWidth,
    position,
    bottom,
    top,
    left,
    right,
    display,
  };

  iframe.style.cssText = deriveRootLayoutCssTextFromProps(layoutProps);

  // Used by integration.css
  iframe.className = `zephrIframeOutcome ${componentName}`;

  iframe.sandbox = [
    'allow-downloads', // download pdf
    'allow-forms', // submit email
    'allow-scripts', // render app
    'allow-top-navigation', // navigate to landing pages
    'allow-same-origin', // allow access to cookies and local storage for analytics $t
    'allow-popups', // allow popups links that use _blank
  ].join(' ');

  const origin = deriveIframeOriginFromRootPageOrigin();

  const webZephrIframeUrlSearchParams = new URLSearchParams(
    webZephrIframePropsMergeTopPageMetadata(webZephrIframeProps),
  );

  const src = `${origin}/components/${componentName}?${webZephrIframeUrlSearchParams.toString()}`;
  iframe.src = src;

  if (isInlineComponent) {
    targetElement.insertAdjacentElement('afterend', iframe);
  } else {
    targetElement.appendChild(iframe);
  }

  const trigger = triggerProp || intent; // backward-compatible with intent
  const selector = `[src^="${src}"]`;
  const options = {
    detail: {
      selector,
      showDelayMilliseconds,
    },
  };

  const eventType =
    trigger === 'exit' ? 'zephrobserveexittrigger' : 'onzephrshowcomponent';

  const event = new CustomEvent(eventType, options);

  return window.dispatchEvent(event);
}

window.addEventListener(
  'onzephrinitializecomponent',
  onZephrInitializeComponent,
);

export default onZephrInitializeComponent;
